import { Component, OnInit, Input, AfterViewInit } from '@angular/core'
import { GridModel, paginationModel, LoadOptModel } from './grid.model'
import { GridService } from './grid.service'
import { GlobService } from 'src/app/shared/glob.service'
import { PageService } from '../../page/page.service'
import { AuthService } from '../../shared/auth.service'
import { CmodalService } from '../cmodal/cmodal.service'
import { UtilService } from 'src/app/shared/util.service'
import { AjaxService } from 'src/app/shared/ajax.service'
import { FormsModule } from '@angular/forms'

@Component({
  selector: 'app-grid',
  templateUrl: './grid.component.html'
})
export class GridComponent implements OnInit, AfterViewInit {
  @Input() model: GridModel
  @Input() ido: string
  @Input() dyn: any

  ctyp = 'grid'
  // glob: any = glob
  // util: any = util
  // ajax: any = ajax

  constructor(public glob: GlobService, private util: UtilService, private pservice: PageService, public service: GridService, public authService: AuthService, public cmodalService: CmodalService, private ajax: AjaxService) {
    service.components = pservice.components.grds
  }

  ngOnInit() {
    this.pservice.components.grds.push(this)

    if (this.ido) {
      this.model = new GridModel()
      this.model.id = this.ido
    }

    if (this.dyn) {
      for (let k of this.dyn)
        eval('this.model.' + k[0] + '="' + k[1] + '"')
    }
  }

  ngAfterViewInit() {
    var thos = this

    if (this.ido)
      this.ajax.execute({
        url: 'grid/grids',
        data: { id: this.ido },
        success: (post) => {
          thos.model = this.service.modifier(post, thos)
          this.service.init(thos.model)
        }
      })
    else
      this.service.init(this.model)
  }

  trackByIdx(index: number, obj: any): any {
    return index;
  }

  row_i(rowv_i: number) {
    return (this.model.pagination ? (this.model.pagination.page_number - 1) * this.model.pagination.page_size : 0) + rowv_i
  }

  talser(talses: any, val: string) {
    return talses.find(x => x == val) ? true : false
  }

}